<template>
  <DashboardTopCardContent
    :callToActionButtonText="$t('L_enter_your_debts')"
    @callToActionCallback="goToMyDebtAndOpenAddADebt"
  >
    <template #main-content>
      <h2 class="text-h2 font-weight-bold text-center">
        {{ $t('L_finish_creating_your_debt_stacking_plan') }}
      </h2>
      <h4 class="text-center font-weight-medium">
        {{ $t('L_you_have_taken_the_first_step_finish') }}
      </h4>
    </template>
  </DashboardTopCardContent>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useDebtSolutionsStore } from '@/modules/debtsolutions/store/debtsolutions.store';
import { RouteNames } from '@/router/routeNames';
import DashboardTopCardContent from '../../DashboardTopCardContent.vue';
import { mapStores } from 'pinia';
import { $t } from '@/i18n/i18n.ts';
import { type RouteLocationNormalizedLoaded, type Router } from 'vue-router';

export default defineComponent({
  name: 'DebtSolutionsV03TopSingle',
  components: { DashboardTopCardContent },
  computed: {
    ...mapStores(useDebtSolutionsStore),
  },
  methods: {
    $t,
    async goToMyDebtAndOpenAddADebt(this: {
      $route: RouteLocationNormalizedLoaded;
      $router: Router;
      debtsolutionsStore: ReturnType<typeof useDebtSolutionsStore>;
    }) {
      this.debtsolutionsStore.setAddADebtOpenFlag(true);
      if (this.$route.path !== '/debtsolutions/mydebt') {
        await this.$router.push({ name: RouteNames.MY_DEBT });
      }
    },
  },
});
</script>
